// Instant service detection from free-text job descriptions.
// Suggests one of the tenant's service options (dropdown values) via keyword scoring.

const RULES = [
  ["Roofing", ["roof leak", "leaking roof", "roof", "slate", "chimney", "flat roof", "felt"]],
  ["Guttering", ["gutter", "downpipe", "fascia", "soffit"]],
  ["Plumbing", ["leak", "pipe", "tap", "toilet", "sink", "cistern", "stopcock", "shower", "overflow", "burst", "water pressure", "bath"]],
  ["Electrical", ["socket", "wiring", "fuse", "light fitting", "lighting", "electric", "rcd", "consumer unit", "eicr", "power cut", "extractor fan"]],
  ["Heating", ["boiler", "radiator", "heating", "thermostat", "hot water", "no heat"]],
  ["Gas Services", ["gas", "hob", "cp12", "gas safety"]],
  ["Drainage", ["blocked drain", "drain", "sewage", "soakaway", "gully", "manhole"]],
  ["Locksmith", ["locked out", "lock", "key"]],
  ["Glazing", ["glazing", "window pane", "glass", "smashed window", "window"]],
  ["Pest Control", ["rats", "mice", "wasps", "pest", "infestation", "cockroach", "bedbug"]],
  ["Cleaning", ["deep clean", "clean"]],
  ["Gardening", ["garden", "hedge", "lawn", "tree", "overgrown"]],
  ["Carpenter", ["carpentry", "joinery", "skirting", "door frame", "cupboard", "shelving", "decking", "door hanging"]],
  ["Bathrooms", ["bathroom"]],
  ["Fire Alarms", ["fire alarm", "smoke detector", "smoke alarm"]],
  ["Air Conditioning", ["air conditioning", "air con", "hvac"]],
  ["Brickwork", ["repointing", "pointing", "brick", "masonry"]],
  ["Painting", ["repaint", "paint", "decorating", "decorate"]],
  ["Proofing", ["damp", "mould", "condensation"]],
  ["Flooring", ["floorboard", "flooring", "carpet", "laminate"]],
];

// Short/ambiguous words that must match as whole words (e.g. "tap" not "tape").
const EXACT = new Set(["tap", "gas", "bath", "tree", "key", "lock", "hob", "clean", "drain", "roof", "pipe", "leak", "glass", "brick", "paint", "sink", "damp", "mould", "window"]);

const kwRegex = (kw) => new RegExp(`\\b${kw}${EXACT.has(kw) ? "\\b" : ""}`, "i");

function stems(s) {
  return s.toLowerCase().split(/[^a-z]+/).filter(w => w.length >= 3).map(w => w.slice(0, 4));
}

function matchOption(canonical, options) {
  const exact = options.find(o => o.toLowerCase() === canonical.toLowerCase());
  if (exact) return exact;
  const cs = new Set(stems(canonical));
  return options.find(o => stems(o).some(x => cs.has(x))) || null;
}

export function detectService(text, options = []) {
  if (!text || !text.trim() || options.length === 0) return null;
  const scores = new Map();
  for (const [service, kws] of RULES) {
    let score = 0;
    for (const kw of kws) {
      if (kwRegex(kw).test(text)) score += kw.includes(" ") ? 2 : 1;
    }
    if (score > 0) scores.set(service, score);
  }
  if (scores.size === 0) return null;
  let best = null, bestScore = 0;
  for (const [service, score] of scores) {
    if (score > bestScore) { best = service; bestScore = score; }
  }
  return matchOption(best, options);
}
